import React from "react";
import PropTypes from "prop-types";
import Downshift from "downshift";
import styled, { css } from "react-emotion";

const propTypes = {
  items: PropTypes.array.isRequired,
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  floatingLabel: PropTypes.bool,
  labelName: PropTypes.string.isRequired,
};

function isDefined(val) {
  if (typeof val === "number") return !isNaN(val);
  return val !== undefined && val !== null && val !== "";
}

class Select extends React.Component {
  selectedItem() {
    const { items, selected } = this.props;
    return items.find(el => el.id === selected);
  }
  itemToString = item => {
    const { labelName } = this.props;
    if (!item) return "";
    return item[labelName];
  };
  render() {
    const { items, onChange, placeholder, labelName, icon, disabled, floatingLabel } = this.props;
    return (
      <Downshift
        onChange={onChange}
        selectedItem={this.selectedItem()}
        itemToString={this.itemToString}
        render={({ getItemProps, isOpen, selectedItem, toggleMenu }) => (
          <div className="relative">
            {floatingLabel && (
              <Label active={isDefined(selectedItem)} icon={Boolean(icon)}>
                {placeholder && placeholder}
              </Label>
            )}
            <div
              className="select-field"
              onClick={toggleMenu}
              style={icon ? undefined : { paddingLeft: 11 }}
            >
              {(selectedItem && selectedItem[labelName]) || (
                <Placeholder>{!floatingLabel && placeholder}</Placeholder>
              )}
            </div>
            {icon && (
              <span className="select-type-icon">
                <img src={icon} alt="" />
              </span>
            )}
            {isOpen ? (
              <div className="select-option-list">
                {items.map(item => (
                  <div
                    className={`select-option ${
                      selectedItem && selectedItem.id === item.id ? disabledClass : ""
                    }`}
                    {...getItemProps({ item })}
                    key={item.id}
                  >
                    {item[labelName]}
                  </div>
                ))}
              </div>
            ) : null}
            {disabled && <DisabledOverlay />}
          </div>
        )}
      />
    );
  }
}

Select.propTypes = propTypes;
export default Select;

const disabledClass = css`
  cursor: not-allowed;
  color: #ccc;
  :hover {
    color: #ccc;
  }
`;

const Label = styled("div")`
  position: absolute;
  top: 8px;
  left: 11px;
  font-weight: 600;
  font-size: 16px;
  font-family: "Barlow Semi Condensed", sans-serif;
  color: #999;
  z-index: 1;
  transition: all 0.35s ease-in-out;
  left: 40px;
  ${props =>
    !props.icon
      ? `
    left: 11px;
  `
      : null}
  ${props =>
    props.active
      ? `
    left: 11px;
    top: -20px;
    font-size: 12px;
  `
      : null}
`;

const DisabledOverlay = styled("div")`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff90;
  cursor: not-allowed;
`;

const Placeholder = styled("span")`
  opacity: 0.5;
`;



// WEBPACK FOOTER //
// ./src/components/form/Select.jsx